import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {AuthService} from "@core-services/auth.service";
import {map} from 'rxjs';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    router.navigate(['/auth/login']).then();
    return false;
  }

  const funcionalidade = route.data['funcionalidade'];
  const acao = route.data['acao'];

  if (funcionalidade) {
    const funcionalidades: string[] = Array.isArray(funcionalidade) ? funcionalidade : [funcionalidade];

    if (funcionalidades.includes('free-page')) {
      return true;
    }

    return authService.getUsuarioLogado().pipe(
      map(user => {
        const temPermissao = funcionalidades.some(fn =>
          user.authorities.includes(`${fn.toLowerCase()}:${acao?.toLowerCase()}`)
        );
        if (!temPermissao) {
          router.navigate(['/auth/no-permission'], { state: { from: 'guard' } }).then();
          return false;
        }
        return true;
      })
    );
  }

  return authService.getUsuarioLogado().pipe(
    map(user => {
      const podeVisualizar = user.authorities?.some(auth => auth.endsWith(':visualizar'));
      if (!podeVisualizar) {
        router.navigate(['/auth/no-permission'], { state: { from: 'guard' } }).then();
        return false;
      }
      return true;
    })
  );
};
